/**
 * StatsCard Component
 * Displays a statistic with icon, value, label, and description
 */

import React from 'react';
import './StatsCard.css';

interface StatsCardProps {
  icon: React.ReactNode;
  value: string | number;
  label: string;
  description: string;
  onClick?: () => void;
}

export const StatsCard: React.FC<StatsCardProps> = ({
  icon,
  value,
  label,
  description,
  onClick,
}) => {
  return (
    <div
      className={`stat-card card ${onClick ? 'clickable' : ''}`}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      <div className="stat-icon">{icon}</div>
      <div className="stat-content">
        <div className="stat-value">{value}</div>
        <div className="stat-label">{label}</div>
        <div className="stat-description">{description}</div>
      </div>
    </div>
  );
};
